/**
 * API client configuration
 */
const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * API fetcher for SWR
 */
export const fetcher = async (url, options = {}) => {
  const token = localStorage.getItem("access_token");
  
  const headers = {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
    ...options.headers,
  };
  
  const response = await fetch(`${API_URL}${url}`, {
    ...options,
    headers,
  });
  
  if (response.status === 401) {
    // Try to refresh token
    const refreshed = await refreshToken();
    if (!refreshed) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user");
      window.location.href = "/login";
      throw new Error("Session expirée");
    }
    // Retry with new token
    const newToken = localStorage.getItem("access_token");
    const retryResponse = await fetch(`${API_URL}${url}`, {
      ...options,
      headers: {
        ...headers,
        Authorization: `Bearer ${newToken}`,
      },
    });
    if (!retryResponse.ok) {
      const error = await retryResponse.json().catch(() => ({}));
      throw new Error(error.detail || "Erreur serveur");
    }
    return retryResponse.json();
  }
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || "Erreur serveur");
  }
  
  return response.json();
};

/**
 * Refresh access token
 */
async function refreshToken() {
  const refreshToken = localStorage.getItem("refresh_token");
  if (!refreshToken) return false;
  
  try {
    const response = await fetch(`${API_URL}/api/auth/refresh`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refresh_token: refreshToken }),
    });
    
    if (!response.ok) return false;
    
    const data = await response.json();
    localStorage.setItem("access_token", data.access_token);
    localStorage.setItem("refresh_token", data.refresh_token);
    localStorage.setItem("user", JSON.stringify(data.user));
    return true;
  } catch {
    return false;
  }
}

/**
 * API client methods
 */
export const api = {
  get: (url) => fetcher(url),
  
  post: (url, data) => fetcher(url, {
    method: "POST",
    body: JSON.stringify(data),
  }),
  
  put: (url, data) => fetcher(url, {
    method: "PUT",
    body: JSON.stringify(data),
  }),
  
  delete: (url) => fetcher(url, { method: "DELETE" }),
};
